module.exports = __webpack_public_path__ + "static/img/bkg.08d40100.png";